import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IChallengeTextDuration } from 'src/shared/models/textDurationResource.model';

const { TEXT_DURATION_CONTENT, TEXT_DURATION_ICON } = ResourceTypeDetailEnum;

export const buildChallengeTextDuration = (
  resource: IResourceList
): IChallengeTextDuration => {
  const { resourceDetailList, name: title } = resource;
  let item: IChallengeTextDuration;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case TEXT_DURATION_CONTENT:
          item = {
            ...item,
            content: value,
          };
          break;
        case TEXT_DURATION_ICON:
          item = {
            ...item,
            contentIcon: value,
          };
          break;
      }
    });

  return {
    ...item,
    title,
  };
};
